module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/Luminary-homepage-3-L-1024x576.258b81c.jpg";